import http from "./httpService";
const apiEndpoint = "https://wms.advanceagro.net/ws2/api/Carpark";

export async function getCarPaylist(
  id = 0,
  year = 0,
  name = "",
  pageSize = 1000,
  pageNumber = 1
) {
  //Getbill?year=2020&month=10&parkid=1
  return http.get(
    apiEndpoint +
      "/CarPaylist?zone=" +
      id +
      "&year=" +
      year +
      "&name=" +
      name +
      "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber
  );
}
export async function getBookinglist(
  name = "",
  pageSize = 1000,
  pageNumber = 1
) {
  //Getbill?year=2020&month=10&parkid=1
  return http.get(
    apiEndpoint +
      "/Bookinglist?name=" +
      name +
      "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber
  );
}
export async function getcarcolor() {
  //Getbill?year=2020&month=10&parkid=1
  return http.get(
    apiEndpoint +
      "/getcarcolor"
  );
}
export async function getcartype() {
  //Getbill?year=2020&month=10&parkid=1
  return http.get(
    apiEndpoint +
      "/getcartype"
  );
}
export async function saveregister(doc) {
  //Getbill?year=2020&month=10&parkid=1
  return http.post(
    apiEndpoint +
      "/register",doc
  );
}
export async function getsliplist(startdate='',enddate='',
  zone = 0,name=""
  ,statusid =0,
  pageSize = 1000,
  pageNumber = 1
) {
  //./src/components/carpark/waitpaylist.jsx?year=2020&month=10&parkid=1
  return http.get(
    apiEndpoint +
      "/sliplist?startdate=" +
      startdate + "&enddate="+ enddate + 
      "&zone="+zone+
      "&name="+name +
      "&statusid="+ statusid +
      "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber
  );
}
export async function getWaitPaylist(
  reportid =0,
  pageSize = 1000,
  pageNumber = 1
) {
  //./src/components/carpark/waitpaylist.jsx?year=2020&month=10&parkid=1
  return http.get(
    apiEndpoint +
      "/GetNoComplete?reportid=" +
      reportid +
      "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber
  );
}
export async function Getbill(year = 0, month = 0, id = 0) {
  //Getbill?year=2020&month=10&parkid=1
  return http.get(
    apiEndpoint + "/Getbill?year=" + year + "&month=" + month + "&parkid=" + id
  );
}
export async function getreportpbx() {
  
  return http.get(
   "/wms/getreportpbx"
  );
}
export async function GetSlip(year = 0, month = 0, id = 0) {
  //Getbill?year=2020&month=10&parkid=1
  return http.get(
    apiEndpoint + "/slipdetial?year=" + year + "&month=" + month + "&id=" + id
  );
}

export async function deleteSlip(doc) {
  return http.post(apiEndpoint + "/deleteSlip", doc);
}

export async function ConfirmByAccount(doc) {
  return http.post(apiEndpoint +"/ConfirmByAccount", doc);
}

export async function getMonthpay(year = 0, id = 0) {
  //Getbill?year=2020&month=10&parkid=1
  return http.get(apiEndpoint + "/getMonth?year=" + year + "&id=" + id);
}
//        public object sliplist(string startdate, string enddate, int zone =0,string name ="",int pageSize = 30, int pageNumber = 1)

export async function GetYear() {
  return http.get(apiEndpoint + "/GetYear");
}
export async function getCarRate(id) {
  return http.get(apiEndpoint + "/getCarRate?id="+id);
}
export async function GetZone() {
  return http.get(apiEndpoint + "/GetZone");
}
export async function GetAppStatus() {
  return http.get(apiEndpoint + "/getApproveStatus");
}
export async function uploadSlipImage(doc) {
  // console.log(http://127.0.0.1:8080/);
  return http.post(
    "https://wms.advanceagro.net/ws2/api/Carpark/UploadSlipImage",
    doc
  );
  //return http.post("http://127.0.0.1:8080/api/Carpark/UploadSlipImage", doc);
}
export default {
  getCarPaylist,getWaitPaylist,
  GetZone,
  GetYear,
  Getbill,
  getBookinglist,
  getMonthpay,
  uploadSlipImage,
  GetSlip,
  deleteSlip,getCarRate,getsliplist,ConfirmByAccount,GetAppStatus,
  getcarcolor,getcartype,saveregister
};
